module.exports = __webpack_public_path__ + "img/Character_Diluc_Thumb.e8a42eda.png";